import { useEffect, useState } from 'react';
import { TransitionalRegistryStatus, useTransitionalRegistryQuery } from '@graphql/generated';

interface TransitionalRegistryStatusInfo {
  dateString?: string;
  status: TransitionalRegistryStatus;
}

export interface GetTransitionalRegistryStatusProps {
  id: string;
  pollingInterval?: number;
}

export const useGetTransitionalRegistryStatus = ({ id, pollingInterval = 5000 }: GetTransitionalRegistryStatusProps) => {
  const [keepPolling, setKeepPolling] = useState(false);
  const [statusInfo, setStatusInfo] = useState<TransitionalRegistryStatusInfo>({ status: TransitionalRegistryStatus.ready });

  const { data, refetch } = useTransitionalRegistryQuery({
    batchMode: 'fast',
    nextFetchPolicy: 'no-cache',
    refetchWritePolicy: 'overwrite',
    variables: { id },
    skip: !id || !keepPolling
  });

  useEffect(() => {
    if (id && keepPolling) {
      const interval = setInterval(() => {
        refetch({ id });
      }, pollingInterval);
      return () => clearInterval(interval);
    }
    return;
  }, [id, pollingInterval, keepPolling, refetch]);

  useEffect(() => setKeepPolling(statusInfo.status === TransitionalRegistryStatus.inProgress), [statusInfo.status]);

  useEffect(() => {
    if (data?.transitionalRegistry) {
      setKeepPolling(data.transitionalRegistry.status === TransitionalRegistryStatus.inProgress);
      setStatusInfo({ status: data.transitionalRegistry.status, dateString: data.transitionalRegistry.scannedAt?.dateString });
    }
  }, [data]);

  return { statusInfo, setStatusInfo };
};
